<template>


    <Transition name="modal-fade">
      <div v-if="isdisplay" class="cf-overlay" @click.self="close">
        <Transition name="modal-slide">
          <div v-if="isdisplay" class="cf-dialog cf-dialog--xxl">

                <!-- Header -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-bar-chart-box-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                            <p class="cf-modal-head__sub">Sélectionnez le rapport à consulter</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>

                <!-- Body -->
                <div class="cf-dialog-body">

                    <div class="grid grid-cols-12 gap-4">

                        <div class="xxl:col-span-4 xl:col-span-4 lg:col-span-6 md:col-span-6 col-span-12">
                            <button @click="btnmodalsuivieca" type="button" class="trf-option">
                                <span class="trf-option__icon trf-option__icon--info"><i class="ri-line-chart-line"></i></span>
                                <span class="trf-option__body">
                                    <span class="trf-option__title">Évolution du chiffre d'affaires par jour</span>
                                    <span class="trf-option__sub">CA journalier au cours d'un mois</span>
                                </span>
                                <i class="ri-arrow-right-line trf-option__arrow"></i>
                            </button>
                        </div>

                        <div class="xxl:col-span-4 xl:col-span-4 lg:col-span-6 md:col-span-6 col-span-12">
                            <button @click="btnmodalsuiviecaparmois" type="button" class="trf-option">
                                <span class="trf-option__icon trf-option__icon--primary"><i class="ri-bar-chart-grouped-line"></i></span>
                                <span class="trf-option__body">
                                    <span class="trf-option__title">Évolution du chiffre d'affaires par mois</span>
                                    <span class="trf-option__sub">CA mensuel au cours d'une année</span>
                                </span>
                                <i class="ri-arrow-right-line trf-option__arrow"></i>
                            </button>
                        </div>

                        <div class="xxl:col-span-4 xl:col-span-4 lg:col-span-6 md:col-span-6 col-span-12">
                            <button @click="btnmodalsuiviefactureimpaye" type="button" class="trf-option">
                                <span class="trf-option__icon trf-option__icon--danger"><i class="ri-time-line"></i></span>
                                <span class="trf-option__body">
                                    <span class="trf-option__title">Vos factures impayées</span>
                                    <span class="trf-option__sub">Suivi des factures en attente de règlement</span>
                                </span>
                                <i class="ri-arrow-right-line trf-option__arrow"></i>
                            </button>
                        </div>

                        <div class="xxl:col-span-4 xl:col-span-4 lg:col-span-6 md:col-span-6 col-span-12">
                            <button @click="btnmodalprincipauxclientetmontant" type="button" class="trf-option">
                                <span class="trf-option__icon trf-option__icon--secondary"><i class="ri-team-line"></i></span>
                                <span class="trf-option__body">
                                    <span class="trf-option__title">Principaux clients et montants dus</span>
                                    <span class="trf-option__sub">Classement des clients sur une année</span>
                                </span>
                                <i class="ri-arrow-right-line trf-option__arrow"></i>
                            </button>
                        </div>

                        <div class="xxl:col-span-4 xl:col-span-4 lg:col-span-6 md:col-span-6 col-span-12">
                            <button @click="btnmodalrelevefacture" type="button" class="trf-option">
                                <span class="trf-option__icon trf-option__icon--success"><i class="ri-file-list-3-line"></i></span>
                                <span class="trf-option__body">
                                    <span class="trf-option__title">Relevé des factures client</span>
                                    <span class="trf-option__sub">Liste détaillée des factures émises</span>
                                </span>
                                <i class="ri-arrow-right-line trf-option__arrow"></i>
                            </button>
                        </div>

                        <div class="xxl:col-span-4 xl:col-span-4 lg:col-span-6 md:col-span-6 col-span-12">
                            <button @click="btnmodalcaparmoisbydoc" type="button" class="trf-option">
                                <span class="trf-option__icon trf-option__icon--warning"><i class="ri-calendar-line"></i></span>
                                <span class="trf-option__body">
                                    <span class="trf-option__title">CA sur une période par mois</span>
                                    <span class="trf-option__sub">Chiffre d'affaires mensuel sur une période donnée</span>
                                </span>
                                <i class="ri-arrow-right-line trf-option__arrow"></i>
                            </button>
                        </div>

                    </div>

                </div>

                <!-- Footer -->
                <div class="cf-dialog-foot">
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>


    <moadalcaparmoisbydoc ref="moadalcaparmoisbydoc"></moadalcaparmoisbydoc>
    <modalsuivieca ref="modalsuivieca"  ></modalsuivieca>
    <modalrelevefacture ref="modalrelevefacture"  ></modalrelevefacture>
    <modalsuiviefactureimpaye ref="modalsuiviefactureimpaye"  ></modalsuiviefactureimpaye>
    <modalsuiviecaparmois ref="modalsuiviecaparmois"  ></modalsuiviecaparmois>
    <modalprincipauxclientetmontant ref="modalprincipauxclientetmontant"  ></modalprincipauxclientetmontant>
    <!--modalimpressiondoc ref="modalimpressiondoc"  ></modalimpressiondoc-->

</template>

<script>

    import modalsuivieca from "@/components/views/pages/gestioncommerciale/rapport/modal_suivie_ca";
    import modalsuiviecaparmois from "@/components/views/pages/gestioncommerciale/rapport/modal_suivie_ca_par_mois";
    import modalsuiviefactureimpaye from "@/components/views/pages/gestioncommerciale/rapport/modal_suiviefactureimpaye";
    import modalprincipauxclientetmontant from "@/components/views/pages/gestioncommerciale/rapport/modal_principauxclientetmontant";
    import modalrelevefacture from "@/components/views/pages/gestioncommerciale/rapport/modal_relevefacture";
    import moadalcaparmoisbydoc from "@/components/views/pages/comptabilite/editions/modal_ca_par_mois_by_doc";



    /*

    import modalopenform from "@/components/views/pages/stock/mvtstock/modal_openform";
    import modalimpressiondoc from "@/components/views/pages/stock/mvtstock/modal_etatdocstock";

    */


    export default {
        /* eslint-disable */
        name: "suivieca",

        watch: {},
        computed:{},
        components: {
            modalsuivieca,
            modalsuiviecaparmois,
            modalsuiviefactureimpaye,
            modalprincipauxclientetmontant,
            modalrelevefacture,
            moadalcaparmoisbydoc,
        },

        data() {
            return {
                isdisplay:false
            };
        },
        methods: {


            btnmodalcaparmoisbydoc(){
                this.$refs.moadalcaparmoisbydoc.show();

            },


            btnmodalrelevefacture(){
                 this.$refs.modalrelevefacture.show();
            },

            btnmodalprincipauxclientetmontant(){
                 this.$refs.modalprincipauxclientetmontant.show();
            },

            btnmodalsuivieca(){
                 this.$refs.modalsuivieca.show();
            },

            btnmodalsuiviefactureimpaye(){
                 this.$refs.modalsuiviefactureimpaye.show();
            },

            btnmodalsuiviecaparmois(){
                 this.$refs.modalsuiviecaparmois.show();
            },




            close(){

                this.isdisplay=false;

                //this.$emit('closed');

            },

            show(titlemodal){


                this.messagesucces="";
                this.messageerror="";
                this.titlemodal="RAPPORT SUR VENTES"
                this.isdisplay=true;

            },








        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1150px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

/* Carte d'option de rapport (pattern trf-option) */
.trf-option { width:100%; height:100%; display:flex; align-items:center; gap:0.85rem; padding:0.8rem 0.9rem; background:#fff; border:1px solid var(--cf-border); border-radius:var(--cf-radius); cursor:pointer; text-align:left; transition:border-color .15s, box-shadow .15s, background-color .15s; }
.trf-option:hover { border-color:rgb(var(--primary) / 0.45); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); background:rgb(var(--primary) / 0.03); }
.trf-option:focus-visible { outline:none; border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.trf-option__icon { flex-shrink:0; width:44px; height:44px; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); font-size:1.35rem; transition:transform .15s; }
.trf-option:hover .trf-option__icon { transform:scale(1.08); }
.trf-option__icon--info { background:rgb(var(--info) / 0.12); color:rgb(var(--info)); }
.trf-option__icon--success { background:rgb(var(--success) / 0.12); color:rgb(var(--success)); }
.trf-option__icon--primary { background:rgb(var(--primary) / 0.10); color:rgb(var(--primary)); }
.trf-option__icon--secondary { background:rgb(var(--secondary) / 0.12); color:rgb(var(--secondary)); }
.trf-option__icon--warning { background:rgb(var(--warning) / 0.15); color:rgb(var(--warning)); }
.trf-option__icon--danger { background:rgb(var(--danger) / 0.10); color:rgb(var(--danger)); }
.trf-option__body { flex:1; min-width:0; display:flex; flex-direction:column; }
.trf-option__title { font-size:0.88rem; font-weight:600; color:var(--cf-ink-strong); transition:color .15s; }
.trf-option:hover .trf-option__title { color:rgb(var(--primary)); }
.trf-option__sub { margin-top:2px; font-size:0.78rem; color:var(--cf-muted); }
.trf-option__arrow { flex-shrink:0; font-size:1.1rem; color:var(--cf-faint); transition:color .15s, transform .15s; }
.trf-option:hover .trf-option__arrow { color:rgb(var(--primary)); transform:translateX(3px); }

/* Transitions */
.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

@media (hover: none) {
    .trf-option:active { opacity: 0.8; }
}

@media screen and (max-width: 768px) {
    .cf-dialog--xxl { max-width:100%; }
}

</style>
